import React from 'react'

import Box from './Box'

export default () => (
  <Box
    display="block"
    width="100%"
    height={100}
    border="3px solid"
    borderColor={{
      xs: 'red',
      sm: 'blue',
      md: 'orange',
      lg: 'tomato',
      xl: 'palevioletred',
    }}
  />
)
